// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonBox_container__k0dF0","loader":"SkeletonBox_loader__USk6o"};